
<div class="ws-spinner">
  <component
    :is="currentSpinner"
    v-bind="$attrs"
    :width="getSpinnerDefaultSize"
    :height="height"
    :color="getSpinnerColor"
  />
  <span v-if="text" class="text q-ml-md">{{ $t(text) }}</span>
</div>
